/* ========================================================
   SIDE LENS MAGNIFIER & FULLSCREEN LIGHTBOX MODAL
   ======================================================== */

// 1. Dynamic Pixel-Accurate Side Lens Magnifier (520px Window / 240px Lens)
function initNanisLensZoom() {
  document.addEventListener('mouseover', function (e) {
    const container = e.target.closest('.product-media-container');
    if (!container || window.innerWidth < 990) return;

    const img = container.querySelector('img');
    if (!img) return;

    let lens = container.querySelector('.side-zoom-lens');
    if (!lens) {
      lens = document.createElement('div');
      lens.className = 'side-zoom-lens';
      container.appendChild(lens);
    }

    let zoomWindow = document.getElementById('side-zoom-preview-window');
    if (!zoomWindow) {
      zoomWindow = document.createElement('div');
      zoomWindow.id = 'side-zoom-preview-window';
      zoomWindow.className = 'side-zoom-preview-window';
      document.body.appendChild(zoomWindow);
    }

    const updateZoom = (event) => {
      if (window.innerWidth < 990) return;

      const rect = container.getBoundingClientRect();
      const mouseX = event.clientX - rect.left;
      const mouseY = event.clientY - rect.top;

      // Enable active class first so offsetWidth and offsetHeight give exact pixels
      lens.classList.add('is-active');
      zoomWindow.classList.add('is-active');

      const lensW = lens.offsetWidth || 240;
      const lensH = lens.offsetHeight || 240;
      const windowW = zoomWindow.offsetWidth || 520;
      const windowH = zoomWindow.offsetHeight || 520;

      // Top-left of lens centered on mouse position
      let lensLeft = mouseX - lensW / 2;
      let lensTop = mouseY - lensH / 2;

      // Clamp lens inside main image bounds
      if (lensLeft < 0) lensLeft = 0;
      if (lensLeft > rect.width - lensW) lensLeft = rect.width - lensW;
      if (lensTop < 0) lensTop = 0;
      if (lensTop > rect.height - lensH) lensTop = rect.height - lensH;

      lens.style.left = lensLeft + 'px';
      lens.style.top = lensTop + 'px';

      // Position side preview window next to main image container
      zoomWindow.style.left = (rect.right + 16) + 'px';
      zoomWindow.style.top = Math.max(16, rect.top) + 'px';
      zoomWindow.style.backgroundImage = `url('${img.currentSrc || img.src}')`;

      // Calculate exact 1-to-1 scale ratios between window and lens
      const scaleX = windowW / lensW;
      const scaleY = windowH / lensH;

      const bgW = rect.width * scaleX;
      const bgH = rect.height * scaleY;
      const bgX = - (lensLeft * scaleX);
      const bgY = - (lensTop * scaleY);

      zoomWindow.style.backgroundSize = `${bgW}px ${bgH}px`;
      zoomWindow.style.backgroundPosition = `${bgX}px ${bgY}px`;
    };

    const handleMouseLeave = () => {
      if (lens) lens.classList.remove('is-active');
      if (zoomWindow) zoomWindow.classList.remove('is-active');
    };

    container.onmousemove = updateZoom;
    container.onmouseleave = handleMouseLeave;
  });
}

// 2. Fullscreen Lightbox Modal Functions (Image 2)
function openLightboxModal(sectionId, initialIdx) {
  const modal = document.getElementById('CustomLightboxModal-' + sectionId) || document.querySelector('.custom-lightbox-modal');
  if (!modal) return;

  modal.classList.add('is-open');
  document.body.style.overflow = 'hidden';

  const thumbBtns = modal.querySelectorAll('.lightbox-thumb-item');
  if (initialIdx < 0 || initialIdx >= thumbBtns.length) initialIdx = 0;

  const targetBtn = thumbBtns[initialIdx];
  const src = targetBtn ? targetBtn.querySelector('img').src : '';

  switchLightboxImage(initialIdx, src);

  document.addEventListener('keydown', handleLightboxEscKey);
}

function switchLightboxImage(idx, src) {
  const modal = document.querySelector('.custom-lightbox-modal');
  if (!modal) return;

  resetLightboxZoom();

  const mainImg = modal.querySelector('#lightbox-main-img');
  const currentCounter = modal.querySelector('#lightbox-current-idx');
  const thumbBtns = modal.querySelectorAll('.lightbox-thumb-item');

  if (thumbBtns[idx]) {
    const fullSrc = thumbBtns[idx].getAttribute('data-full-src');
    if (fullSrc) {
      src = fullSrc;
    } else {
      const thumbImg = thumbBtns[idx].querySelector('img');
      if (thumbImg) src = thumbImg.src;
    }
  }

  if (mainImg && src) {
    mainImg.src = src;
  }

  if (currentCounter) {
    currentCounter.textContent = (idx + 1);
  }

  thumbBtns.forEach((btn, i) => {
    if (i === idx) {
      btn.classList.add('active');
    } else {
      btn.classList.remove('active');
    }
  });
}

function stepLightboxImage(direction) {
  const modal = document.querySelector('.custom-lightbox-modal');
  if (!modal) return;
  const thumbBtns = Array.from(modal.querySelectorAll('.lightbox-thumb-item'));
  if (!thumbBtns.length) return;

  let activeIdx = thumbBtns.findIndex(btn => btn.classList.contains('active'));
  if (activeIdx === -1) activeIdx = 0;

  let nextIdx = (activeIdx + direction + thumbBtns.length) % thumbBtns.length;
  const targetBtn = thumbBtns[nextIdx];
  const fullSrc = targetBtn.getAttribute('data-full-src') || targetBtn.querySelector('img').src;
  switchLightboxImage(nextIdx, fullSrc);
}

function closeLightboxModal() {
  const modal = document.querySelector('.custom-lightbox-modal');
  if (!modal) return;
  resetLightboxZoom();
  modal.classList.remove('is-open');
  document.body.style.overflow = '';
  document.removeEventListener('keydown', handleLightboxEscKey);
}

function closeLightboxOnBackdrop(event) {
  if (event.target.classList.contains('custom-lightbox-modal') || event.target.classList.contains('lightbox-content-wrapper')) {
    closeLightboxModal();
  }
}

function handleLightboxEscKey(e) {
  if (e.key === 'Escape') {
    closeLightboxModal();
  } else if (e.key === 'ArrowLeft') {
    stepLightboxImage(-1);
  } else if (e.key === 'ArrowRight') {
    stepLightboxImage(1);
  }
}

// 3. Interactive Click-to-Zoom & Pan inside Lightbox Modal
function toggleLightboxZoom(imgEl, event) {
  if (event) event.stopPropagation();
  if (!imgEl) return;

  const wrapper = imgEl.closest('.lightbox-content-wrapper') || imgEl.parentElement;
  if (!wrapper) return;

  const isZoomed = wrapper.classList.contains('is-zoomed');

  if (isZoomed) {
    resetLightboxZoom();
  } else {
    wrapper.classList.add('is-zoomed');
    imgEl.classList.add('is-zoomed');
    imgEl.style.cursor = 'zoom-out';
    updateLightboxPan(event, imgEl);
  }
}

function updateLightboxPan(e, mainImg) {
  if (!mainImg) return;
  const rect = mainImg.getBoundingClientRect();
  if (!rect.width || !rect.height) return;

  const clientX = e ? e.clientX : rect.left + rect.width / 2;
  const clientY = e ? e.clientY : rect.top + rect.height / 2;

  const x = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
  const y = Math.max(0, Math.min(100, ((clientY - rect.top) / rect.height) * 100));

  mainImg.style.transformOrigin = `${x}% ${y}%`;
  mainImg.style.transform = 'scale(2.5)';
}

function resetLightboxZoom() {
  const wrappers = document.querySelectorAll('.lightbox-content-wrapper');
  wrappers.forEach(wrapper => {
    wrapper.classList.remove('is-zoomed');
    const mainImg = wrapper.querySelector('#lightbox-main-img');
    if (mainImg) {
      mainImg.classList.remove('is-zoomed');
      mainImg.style.cursor = 'zoom-in';
      mainImg.style.transform = 'scale(1)';
      mainImg.style.transformOrigin = 'center center';
    }
  });
}

function initLightboxZoom() {
  document.addEventListener('mousemove', function (e) {
    const wrapper = document.querySelector('.lightbox-content-wrapper.is-zoomed');
    if (!wrapper) return;
    const mainImg = wrapper.querySelector('#lightbox-main-img');
    if (mainImg) {
      updateLightboxPan(e, mainImg);
    }
  });
}

// Auto-initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initNanisLensZoom();
    initLightboxZoom();
  });
} else {
  initNanisLensZoom();
  initLightboxZoom();
}
window.addEventListener('load', function() {
  initNanisLensZoom();
  initLightboxZoom();
});



